import request from "./request";

const TimerService = {
    Save: async (payload, context) => {
        return await request.sendPostRequest(`/timer`, payload, context);
    },
};

export default TimerService;
